// extracted by mini-css-extract-plugin
export default {"container":"ResellerPage-module--container--1ctKz"};